import AppSettings from '../AppSettings';
import RouteDefinitions from '../RouteDefinitions';
import { StoreUrlBuilder } from './StoreUrlBuilder';
import { AbsoluteUrl } from './Url';

export interface IShareModularConfiguratorUrlProvider {
  initialize(productFamilyId: string): void;
  getUrl(code: string): string;
}

export class ShareModularConfiguratorUrlProvider implements IShareModularConfiguratorUrlProvider {
  private productFamilyId: string;

  public initialize(productFamilyId: string) {
    this.productFamilyId = productFamilyId;
  }

  public constructor(protected readonly settings: AppSettings) {}

  public getUrl(code: string): string {
    const relativeUrl = StoreUrlBuilder.withContext(
      RouteDefinitions.getUrlTo((x) => x.modularConfiguratorRoute, { productFamilyId: this.productFamilyId }),
      new Map<string, string>([['code', code]]),
      true,
    );

    return AbsoluteUrl.parse(this.settings.baseUrl).append(relativeUrl).toString();
  }
}
